import { z } from 'zod';

export const vehicleFeatureSchema = z.object({
    vehicleFeature_id: z.number(),
    name: z.string(),
});
export type TVehicleFeature = z.infer<typeof vehicleFeatureSchema>;
